import React from "react";

import { generateDescription, generateTitle } from "../../textFunctions";
import styles from "./controlsPanel.module.css";

export default function ControlsPanel({
  name,
  setName,
  creationYear,
  setCreationYear,
  birthYear,
  setBirthYear,
  media,
  setMedia,
  title,
  setTitle,
  description,
  setDesciption,
}) {
  return (
    <div className={styles.controlsPanel}>
      <div className={styles.arrowUp} />
      <div className={styles.arrowRight} />

      <div className={styles.content}>
        <TextInput label="Artist Name" value={name} onChange={setName} />
        <TextInput
          label="Artwork Title"
          value={title}
          onChange={setTitle}
          generateFunction={() => setTitle(generateTitle())}
        />
        <TextInput
          generateFunction={() => setDesciption(generateDescription())}
          useTextArea="true"
          label="Description"
          value={description}
          onChange={setDesciption}
        />
        <TextInput label="Medium Used" value={media} onChange={setMedia} />
        <TextInput
          label="Artist Birth Year"
          value={birthYear}
          onChange={setBirthYear}
        />
        <TextInput
          label="Artwork Creation Year"
          value={creationYear}
          onChange={setCreationYear}
        />
      </div>
    </div>
  );
}

const TextInput = ({
  label,
  value,
  onChange,
  generateFunction,
  useTextArea,
}) => {
  return (
    <div className={styles.textInput}>
      <div className={styles.inputLabel}>
        {`${label}:`}{" "}
        {generateFunction && (
          <button onClick={generateFunction}>GENERATE</button>
        )}
      </div>
      {useTextArea ? (
        <textarea
          style={{ width: "100%", minWidth: 250, minHeight: 110 }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </div>
  );
};
